"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { forwardLink } from './styles.js';
import { IconArrowRight } from '../icons/ui_navigation/IconArrowRight.web.js';
import { useBoolean } from '../utils/hooks/useBoolean.js';
import { AnimatedCircle } from '../Icon/AnimatedCircle/AnimatedCircle.web.js';
import { callOptional } from '../utils/helpers/function.js';
import { spacing } from '../constants/spacing.js';

var _excluded = ["children", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
function ForwardLinkComponent(_ref, ref) {
  var children = _ref.children,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useBoolean = useBoolean(false),
    visible = _useBoolean.value,
    setFalse = _useBoolean.setFalse,
    setTrue = _useBoolean.setTrue;
  var handleOnFocus = React.useCallback(function (event) {
    setTrue();
    callOptional(onFocus)(event);
  }, [setTrue, onFocus]);
  var handleOnBlur = React.useCallback(function (event) {
    setFalse();
    callOptional(onBlur)(event);
  }, [setFalse, onBlur]);
  var handleMouseEnter = React.useCallback(function (event) {
    setTrue();
    callOptional(onMouseEnter)(event);
  }, [setTrue, onMouseEnter]);
  var handleMouseLeave = React.useCallback(function (event) {
    setFalse();
    callOptional(onMouseLeave)(event);
  }, [setFalse, onMouseLeave]);
  return /*#__PURE__*/React.createElement(forwardLink, _extends({
    noUnderline: true,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    disableVisited: true,
    ref: ref,
    showExternalIcon: false
  }, props), children, /*#__PURE__*/React.createElement(AnimatedCircle, {
    visible: visible,
    slide: visible,
    ml: spacing.xxxs
  }, /*#__PURE__*/React.createElement(IconArrowRight, {
    size: 24
  })));
}
var ForwardLink = /*#__PURE__*/React.forwardRef(ForwardLinkComponent);

export { ForwardLink };
